//const datepicker = require('js-datepicker');
/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).foundation();

jQuery(window).ready(function($) {
	
	// jump nav
	if ($('.jump-nav-wrap').length > 0) {
		$(window).on('scroll', function() {
			var pos = $(window).scrollTop();
			var jmpmenu = $('.jump-nav-wrap').position().top;
			if (pos > jmpmenu) {
				$('.jump-nav-wrap').addClass('is-stuck');
			} else {
				$('.jump-nav-wrap').removeClass('is-stuck');
			}
			$('.jump-nav-wrap li').removeClass('expanded');
		}).scroll();
	}
	$('.jump-nav-wrap .has-children').click(function(e) {
		e.preventDefault();
		$('.jump-nav-wrap li').removeClass('expanded');
		$(this).parent().toggleClass('expanded');
	});
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	$('.datepicker').each(function() {
		datepicker($(this).get( 0 ), {
		  formatter: (input, date, instance) => {
			const value = date.toLocaleDateString()
			input.value = value // => '1/1/2099'
		  }
		});
	});
	
    function handleMainNavClicked(e) {
        if (Foundation.MediaQuery.atLeast('large')) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                closeMainSubMenu();
            } else {
                openMainSubMenu($(this).data('opens'));
            }
        }
    }
    function openMainSubMenu(subMenuID) {
        if ($('#' + subMenuID).length > 0 && !$('#' + subMenuID).hasClass('active')) {
            // check if aleady expanded
            var currentExpandedHeight = ($('.main-nav-panel.active').length > 0) ? $('.main-nav-panel.active').outerHeight() : 0;
            // get target panel height
            $('#' + subMenuID).addClass('height-check');
            var contentHeight = $('#' + subMenuID).find('.inner').outerHeight();
            $('#' + subMenuID).removeClass('height-check');
            //
            $('#' + subMenuID).height(currentExpandedHeight); // start at the height of the current;
            $('.main-nav-panel.active').removeAttr('style'); // clear the height
            //
            // remove active classes
            $('.main-nav-panel').removeClass('active');
            $('.main-nav-lnk').removeClass('active');
            //
            if (!isNaN(contentHeight) && contentHeight > 0) {
                $('.site-header').addClass('dd-expanded');
                $('body').addClass('dd-expanded');
                $('#' + $('#' + subMenuID).attr('aria-labelledby')).addClass('active'); // mark nav as active
                $('#' + subMenuID).addClass('active');
                $('.main-nav-panel.active').stop().animate({
                    height: contentHeight + 'px',
                }, {
                    progress: function(anim, prog, remain) {
                        readjustHeroNavPad(prog);
                    },
                    duration: 400
                });
            }
        }
    }
    function closeMainSubMenu() {
        $('body').addClass('dd-closing');
        $('.main-nav-panel.active').stop().animate({
            height:0
        }, 800, function() {
            $('.site-header').removeClass('dd-expanded');
            $('body').removeClass('dd-expanded');
            $('body').removeClass('dd-closing');
            $('.main-nav-panel').removeClass('active');
            $('.main-nav-lnk').removeClass('active');
        });
        $('.main-wrap > .spacer').stop().animate({
            height: 1,
        }, 600);
    }
    function readjustHeroNavPad(easePercentage) {
        var pad = 0;
        if (Foundation.MediaQuery.atLeast('large')) {
            if ('undefined' === typeof(easePercentage)) { easePercentage = 1; }
            if (easePercentage < 0) { easePercentage = 0; }
            if (easePercentage > 1) { easePercentage = 1; }
            var height = $('.site-main-nav').outerHeight();
            var breadcrumbHeight = isNaN($('.breadcrumbs').outerHeight()) ? 0 : $('.breadcrumbs').outerHeight();
            var currentPad = $('.main-wrap > .spacer').height();
            var distance = (height - breadcrumbHeight) - currentPad;
            pad = (currentPad + (distance * easePercentage));
            console.log('currentPad: ' + currentPad + ' | height: ' + height + ' | distance: ' + distance + ' | ease: ' + easePercentage);
        }
        $('.main-wrap > .spacer').height(pad);
    }
	$('.main-nav').addClass('js-enabled');
    $('.main-nav .main-nav-lnk.has-sub-menu').on('click', handleMainNavClicked);
    $(window).on('resize', closeMainSubMenu);
    //
    // PARALLAX DIVIDER
    if ($('.flex-parallax-divider').length > 0) {
        var num = 0;
        $.each($('.flex-parallax-divider'), function() {
            num = num + 1;
            if (num > 4) num = 1;
            $(this).addClass('bg-' + num);
        });
        $(window).scroll(function() {
            // dividers
            var pos = $(window).scrollTop();
            $.each($('.flex-parallax-divider'), function() {
                var top = $(this).offset().top;
                var bottom = $(this).offset().top + $(this).outerHeight(true) - $(window).height();
                $(this).removeClass('pos-below').removeClass('pos-above').removeClass('pos-in');
                if (pos < top) {
                    $(this).addClass('pos-below');
                } else if (pos > bottom) {
                     $(this).addClass('pos-above');      
                } else {
                    $(this).addClass('pos-in');
                }
                $(this).data('top', top);
                $(this).data('bottom', bottom);
            });
        }).scroll();
    }
    
    // CAROUSELS
    $('.header-carousel').slick();
    $('.secondary-features-carousel').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
        responsive: [ { breakpoint: 760, settings: { slidesToShow: 1 } } ]
    });
});